export default "__VITE_ASSET__Bmlh4OUi__"